import { render, staticRenderFns } from "./CreateTransactionForm.vue?vue&type=template&id=5d4af45c&scoped=true&"
import script from "./CreateTransactionForm.vue?vue&type=script&lang=js&"
export * from "./CreateTransactionForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateTransactionForm.vue?vue&type=style&index=0&id=5d4af45c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4af45c",
  null
  
)

export default component.exports